import { library, config } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import {
	faBars,
	faCalendarDays,
	faChevronDown,
	faEnvelope,
	faPhone,
	faChevronUp,
	faGlobe,
	faTimes,
} from '@fortawesome/pro-light-svg-icons';

import {
	faFacebook,
	faInstagram,
	faLinkedin,
	faPinterest,
	faSoundcloud,
	faSpotify,
	faTwitter,
	faWhatsapp,
	faYoutube,
} from '@fortawesome/free-brands-svg-icons';

import {
	faArrows,
	faBedAlt,
	faBellConcierge,
	faCheck,
	faEuroSign,
	faMinus,
	faPlay,
	faPlus,
	faRulerCombined,
	faSearch,
	faStar,
	faStars,
	faQuoteLeft,
	faStarHalf,
	faUsers,
	faFanTable,
	faTv,
	faWifi,
	faHotel,
} from '@fortawesome/pro-solid-svg-icons';

// This is important, we are going to let Nuxt.js worry about the CSS
config.autoAddCss = false;

library.add(
	faArrows,
	faBars,
	faHotel,
	faBedAlt,
	faBellConcierge,
	faCheck,
	faChevronUp,
	faChevronDown,
	faCalendarDays,
	faEnvelope,
	faFanTable,
	faTimes,
	faTv,
	faWifi,
	faEuroSign,
	faGlobe,
	faQuoteLeft,
	faFacebook,
	faInstagram,
	faLinkedin,
	faMinus,
	faPinterest,
	faPhone,
	faPlay,
	faPlus,
	faRulerCombined,
	faSearch,
	faSoundcloud,
	faSpotify,
	faStars,
	faTwitter,
	faUsers,
	faWhatsapp,
	faYoutube,
	faStar,
	faStarHalf,
);

export default defineNuxtPlugin(({ vueApp }) => {
	vueApp.component('font-awesome-icon', FontAwesomeIcon, {});
});
